<template>
  <div class="down-container">
    <div class="title">
      <div class="ft28">让阅读成为习惯</div>
      <div class="ft22">海量绘本识读，支持主流英语</div>
    </div>
    <img src="../../assets/img/download-screenshot.png" alt="" class="screenshot">
    <a v-if="IsAndroid" href="http://upgrade.qn.xiaohebook.com/xiaohe_release_v1.0.0_qrcode_202010271722.apk" class="btn">
      <img src="../../assets/img/android-icon.png" alt="" class="btn-icon android-icon">
      <span>Android版本</span>
    </a>
    <a v-else-if="IsIos" href="https://apps.apple.com/cn/app/id1537346000" class="btn">
      <img src="../../assets/img/iphone-icon.png" alt="" class="btn-icon iphone-icon">
      <span>iPhone版本</span>
    </a>
    <div v-else>
      <a href="http://upgrade.qn.xiaohebook.com/xiaohe_release_v1.0.0_qrcode_202010271722.apk" class="btn android">
        <img src="../../assets/img/android-icon.png" alt="" class="btn-icon android-icon">
        <span>Android版本</span>
      </a>
      <a href="https://apps.apple.com/cn/app/id1537346000" class="btn iphone">
        <img src="../../assets/img/iphone-icon.png" alt="" class="btn-icon iphone-icon">
        <span>iPhone版本</span>
      </a>
    </div>
    <img src="../../assets/img/download-bottom.png" alt="" class="bottom">
    <div v-if="IsWechat" class="wechat-mask">
      <img src="../../assets/img/guide-arrow.png" alt="" class="guide-arrow">
      <div class="tips">
        <p>
          <span>1、点击右上角</span>
          <img src="../../assets/img/more-icon.png" alt="" class="more-icon">
        </p>
        <p>
          <span>2、选择在浏览器打开</span>
          <img src="../../assets/img/browser-icon.png" alt="" class="browser-icon">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { TOOL } from '@/utils/tool'

export default {
  name: "Download",
  data() {
    return {
      IsIos: null,
      IsAndroid: null,
      IsWechat: null
    }
  },
  created() {
    this.IsIos = TOOL.IsIos()
    this.IsAndroid = TOOL.IsAndroid()
    this.IsWechat = TOOL.IsWechat()
    if (this.IsWechat) return
    if (this.IsIos) {
      location.href = 'https://apps.apple.com/cn/app/id1473763430'
    } else {
      location.href = 'https://download.51wanxue.com/downloadApp.html?_qaz=D0B2F04A-D9E0-4B75-8940-EEC6646A463A&&_wsx=0'
    }
  }
}
</script>

<style scoped>
.down-container{
  position: relative;
  width: 100%;
  background-color: #a2e679;
  padding-top: 30px;
  text-align: center;
}

.title{
  text-align: center;
  color: #fff;
}


.ft28{
  font-size: 28px;
  font-width: 700;
  margin-bottom: 10px;
}

.ft22{
  font-size: 22px;
}

.screenshot{
  width: 230px;
  height: 451px;
  margin: 50px 0;
}

.bottom{
  display: block;
  width: 100%;
}

.btn{
  display: block;
  width: 170px;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border-radius: 20px;
  text-align: center;
  font-size: 14px;
  color: #64c844;
  font-weight: 700;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  margin: 0 auto 20px;
}

.btn.android{
  /*bottom: 160px !important;*/
}

.btn.iphone{
  margin-top: 20px;
}

.btn-icon{
  position: relative;
  top: 7px;
  margin-right: 10px;
}

.android-icon{
  width: 25px;
  height: 26px;
}

.iphone-icon{
  width: 22px;
  height: 26px;
}

.wechat-mask{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
}

.guide-arrow{
  position: absolute;
  top: 10px;
  right: 25px;
  width: 50px;
  height: 70px;
}

.tips{
  position: absolute;
  width: 80%;
  text-align: left;
  background-color: #EBEBEB;
  border-radius: 10px;
  font-size: 18px;
  top: 90px;
  left: 10%;
  padding: 20px 0 30px 20px;
  box-sizing: border-box;
}

.tips p{
  margin: 0;
}

.more-icon{
  position: relative;
  width: 40px;
  height: 26px;
  top: 5px;
  left: 10px;
}

.browser-icon{
  position: relative;
  width: 40px;
  height: 40px;
  top: 15px;
  left: 10px;
}
</style>